import React, { Suspense } from 'react';
import Routes from './Routes';
import { BrowserRouter as Router } from 'react-router-dom';
import { ModalProvider } from './context/ModalContext';
import { ModalRoot } from './components/shared/modals/ModalRoot';
import './App.scss';

function App() {
  return (
    <Router>
      <ModalProvider>
        <div className="App">
          <Suspense fallback={<div>Carregando...</div>}>
            <Routes />
          </Suspense>
          <ModalRoot />
        </div>
      </ModalProvider>
    </Router>
  );
}

export default App;
